import { all, call, put, takeLatest } from 'redux-saga/effects'
import DashboardTypes from './dashboard-types'
import * as dashboardActions from './dashboard-actions'
import { getRequest } from 'api/apiUtils'
import { IS_PRODUCTION } from 'utils/helperConfig'

function* startFetchDashboards() {
    try {
        const { data: dashboards } = yield getRequest('/user/dashboards')
        yield put(dashboardActions.successFetchDashboards(dashboards))
    } catch (err) {
        if (!IS_PRODUCTION) {
            console.log('err fetching dashboards', err?.response?.data)
        }
    }
}

export function* onStartFetchDashboard() {
    yield takeLatest(DashboardTypes.START_FETCH_DASHBOARDS, startFetchDashboards)
}

export function* dashboardSagas() {
    yield all([call(onStartFetchDashboard)])
}
